import {Component, ChangeDetectionStrategy} from "@angular/core";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import {SessionStorage} from "@shared/SessionStorage";

import { PageHeaderComponent } from "../page-header/page-header.component";
import { ScalarCloseComponent } from "./scalar-close/scalar-close.component";

@Component({
    selector: "my-element",
    templateUrl: "./element.component.html",
    styleUrls: ["./element.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageHeaderComponent, ScalarCloseComponent, RouterOutlet]
})
export class ElementComponent {
    constructor(private activatedRoute: ActivatedRoute) {}

    public isAdmin(): boolean {
        return SessionStorage.isAdmin;
    }

    public isCTalkAdmin(): boolean {
        const params: any = this.activatedRoute.snapshot.queryParams;
        return params.pid === 'ctalk_admin';
    }
}
